import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setMarketingSmsConsent = {
  name: "setMarketingSmsConsent" as const,
  input: z.object({ consented: z.boolean() }),
  output: z.object({
    consented: z.boolean(),
    consentedAt: zExt.instant().nullable(),
  }),
};
